// src/config/resolveLocation.js

import { locationRegistry } from "./locationRegistry";

export async function resolveLocation() {
  const buildDefault = import.meta.env.VITE_LOCATION ?? "cloud";

  // dev convenience: skip network probing entirely if run locally
  if (import.meta.env.DEV) return buildDefault;

  // prod: always probe for a local site first, fall back to build default
  const detected = await detectLocation(); // returns "vinterbro" | "vagle" | null
  return detected ?? buildDefault;
}

const PROBE_SITES = Object.keys(locationRegistry).filter(
  (key) => key !== "cloud"
);

export async function resolveApiUrl(location) {
  const config = locationRegistry[location];

  try {
    const response = await fetch(
      `${config.api.primary}${config.api.healthPath}`,
      {
        signal: AbortSignal.timeout(1000),
      }
    );

    if (response.ok) {
      return config.api.primary;
    }
  } catch {
    return;
  }

  return config.api.fallback ?? config.api.primary;
}

export async function detectLocation(timeoutMs = 1000) {
  const probes = PROBE_SITES.map(async (key) => {
    try {
      const response = await fetch(
        `${locationRegistry[key].api.primary}${locationRegistry[key].api.healthPath}`,
        {
          signal: AbortSignal.timeout(timeoutMs),
        }
      );

      return response.ok ? key : null;
    } catch {
      return null;
    }
  });

  const results = await Promise.all(probes);

  return results.find(Boolean) ?? "cloud";
}
